import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiFetch } from "./api";

function ClientDetail() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [editableClient, setEditableClient] = useState(null);
  const [saveStatus, setSaveStatus] = useState("");

  function loadClient() {
    apiFetch(`/api/clients/${id}`)
      .then(res => res.json())
      .then(data => {
        setClient(data);
        setEditableClient(data);
      });
  }

  useEffect(() => {
    loadClient();
  }, [id]);

  function updateField(field, value) {
    setEditableClient(prev => ({ ...prev, [field]: value }));
  }

  function saveClient() {
    apiFetch(`/api/clients/${id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editableClient)
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          alert(data.error);
          return;
        }
        setSaveStatus("Saved");
        loadClient();
        setTimeout(() => setSaveStatus(""), 1500);
      });
  }

  if (!client || !editableClient) return <div style={page}>Loading...</div>;

  return (
    <div style={page}>
      <button onClick={() => (window.location.href = "/")}>Back to Clients</button>
      <h2>{client.name}</h2>

      <div style={actionRow}>
        <button onClick={() => (window.location.href = `/clients/${id}/sales`)}>Sales</button>
        <button onClick={() => (window.location.href = `/clients/${id}/projects`)}>Projects</button>
      </div>

      <div style={card}>
        <h3>Client Details</h3>
        <table border="1" cellPadding="8" style={table}>
          <tbody>
            <DetailRow label="Client Name" value={editableClient.name} onChange={value => updateField("name", value)} />
            <DetailRow label="Client Address" value={editableClient.address} onChange={value => updateField("address", value)} />
            <DetailRow label="Contact Person Name" value={editableClient.contact_name} onChange={value => updateField("contact_name", value)} />
            <DetailRow label="Contact Person Phone" value={editableClient.contact_phone} onChange={value => updateField("contact_phone", value)} />
            <DetailRow label="Contact Person Email" value={editableClient.contact_email} onChange={value => updateField("contact_email", value)} />
          </tbody>
        </table>
        <button style={{ marginTop: "10px" }} onClick={saveClient}>Save Client Details</button>
        {saveStatus && <span style={successText}>{saveStatus}</span>}
      </div>
    </div>
  );
}

function DetailRow({ label, value, onChange }) {
  return (
    <tr>
      <th style={{ textAlign: "left", width: "260px" }}>{label}</th>
      <td>
        <input style={{ width: "100%" }} value={value || ""} onChange={e => onChange(e.target.value)} />
      </td>
    </tr>
  );
}

const page = { padding: "20px" };
const actionRow = { display: "flex", gap: "10px", margin: "15px 0" };
const card = { border: "1px solid #ddd", padding: "15px", marginTop: "20px", borderRadius: "8px", backgroundColor: "#f9f9f9" };
const table = { width: "100%", borderCollapse: "collapse" };
const successText = { color: "green", fontWeight: "bold", marginLeft: "10px" };

export default ClientDetail;

